import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

export default function PatientSearch({ cases = [] }) {
  const patients = React.useMemo(() => {
    const caseCollection = Array.isArray(cases?.cases) ? cases.cases : [];

    return caseCollection.map((rescase, index) => ({
      id: rescase?.case?.case_controlnum || `${index}-${rescase?.case?.case_patientname || 'patient'}`,
      name: rescase?.case?.case_patientname || 'Unknown Patient',
      mrn: rescase?.case?.case_controlnum || 'Unknown MRN',
    }));
  }, [cases]);

  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState('');
  const [selectedPatient, setSelectedPatient] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const filteredPatients = patients.filter((patient) => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return true;
    }

    return (
      patient.name.toLowerCase().includes(normalizedQuery) ||
      patient.mrn.toLowerCase().includes(normalizedQuery)
    );
  });

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    handleClose();
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '16px 0' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickOpen}
          sx={{
            px: 3,
            py: 1.25,
            fontWeight: 700,
            borderRadius: 999,
            boxShadow: 3,
            zIndex: 1200,
          }}
        >
          Patient Search
        </Button>
      </div>

      {selectedPatient && (
        <p style={{ marginTop: '12px' }}>
          Selected patient: <strong>{selectedPatient.name}</strong> ({selectedPatient.mrn})
        </p>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Search Patients</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Search for a patient by name or medical record number.
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            id="patient-search"
            label="Search patient"
            type="text"
            fullWidth
            variant="outlined"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />

          <List sx={{ maxHeight: 260, overflow: 'auto', mt: 2 }}>
            {filteredPatients.length > 0 ? (
              filteredPatients.map((patient) => (
                <ListItemButton
                  key={patient.id}
                  onClick={() => handleSelectPatient(patient)}
                >
                  <ListItemText
                    primary={patient.name}
                    secondary={patient.mrn}
                  />
                </ListItemButton>
              ))
            ) : (
              <ListItemButton disabled>
                <ListItemText primary="No patients found" />
              </ListItemButton>
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}